module.exports = __webpack_public_path__ + "prod/1.42.2/img/haikang-icon.69920902.png";